import { render, staticRenderFns } from "./ConfiguracionSMTP.vue?vue&type=template&id=c9a539aa&"
import script from "./ConfiguracionSMTP.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionSMTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports